import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusMyProgramMembershipQueryVariables = Types.Exact<{
  input: Types.PullMyEpocusProgramsInput;
}>;


export type EpocusMyProgramMembershipQuery = { readonly __typename?: 'Query', readonly pullMyEpocusPrograms: { readonly __typename?: 'PullMyEpocusProgramsResponse', readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableEpocusProgram', readonly id: string }> } };


export const EpocusMyProgramMembershipDocument = gql`
    query EpocusMyProgramMembership($input: PullMyEpocusProgramsInput!) {
  pullMyEpocusPrograms(input: $input) {
    documents {
      id
    }
  }
}
    `;

/**
 * __useEpocusMyProgramMembershipQuery__
 *
 * To run a query within a React component, call `useEpocusMyProgramMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusMyProgramMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusMyProgramMembershipQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusMyProgramMembershipQuery(baseOptions: Apollo.QueryHookOptions<EpocusMyProgramMembershipQuery, EpocusMyProgramMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusMyProgramMembershipQuery, EpocusMyProgramMembershipQueryVariables>(EpocusMyProgramMembershipDocument, options);
      }
export function useEpocusMyProgramMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusMyProgramMembershipQuery, EpocusMyProgramMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusMyProgramMembershipQuery, EpocusMyProgramMembershipQueryVariables>(EpocusMyProgramMembershipDocument, options);
        }
export type EpocusMyProgramMembershipQueryHookResult = ReturnType<typeof useEpocusMyProgramMembershipQuery>;
export type EpocusMyProgramMembershipLazyQueryHookResult = ReturnType<typeof useEpocusMyProgramMembershipLazyQuery>;
export type EpocusMyProgramMembershipQueryResult = Apollo.QueryResult<EpocusMyProgramMembershipQuery, EpocusMyProgramMembershipQueryVariables>;